import React from "react";

const SystemConfigActionsBar = ({ message, isDirty, saving, onSave, t }) => (
  <div className="system-config-actions">
    {message ? <span className="system-config-message">{message}</span> : <span />}
    <button type="button" className="devices-primary-btn" disabled={!isDirty || saving} onClick={onSave}>
      {saving ? t.saving : t.save}
    </button>
  </div>
);

export default SystemConfigActionsBar;
